import publicIp from 'public-ip';

export const getClientIp = async () => {
  const res = await publicIp.v4({
    fallbackUrls: ['https://ifconfig.co/ip'],
  });
  return res;
};
